import React from 'react'
import '../News/components/css/style.scss'

export default () => {
  return (
    <div className="agreement_app">
      <div className="main">
        <div className="info">
          <h2><a id="Privacy"></a>光宇保护隐私条款</h2>
          保障用户个人隐私安全是光宇游戏的法定义务。北京光宇在线科技有限责任公司（注册地址：北京市海淀区上地东路1号院1号楼盈创动力大厦A座502室；联系方式：010-82438999；以下或称“我们”）将通过光宇游戏《隐私协议》向您进一步释明您在使用光宇游戏时我们对您个人信息的处理情况，以及您所享有的相关权利的事宜：
          <ul>
            <li>
              <h4><strong>1.我们收集的信息</strong></h4>
              <p>
                在您使用光宇游戏服务的过程中，光宇游戏会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供、优化我们的服务以及保障您的账户安全：
              </p>

              <p>1.1 当您注册或使用光宇游戏服务时，我们会收集您的网络身份标识信息及个人常用设备信息，用于标记您为光宇游戏的用户。</p>
              <p>1.2 为满足相关法律法规政策及相关主管部门的要求，光宇游戏用户需进行实名认证以继续使用和享受光宇游戏。<strong>我们会在获得您同意或您主动提供的情况下收集您的实名身份信息（包括姓名、身份证号、照片等信息），该信息属于敏感信息，拒绝提供实名身份信息可能会导致您无法登录光宇游戏或在使用光宇游戏过程中受到相应限制。</strong></p>
              <p>1.3 为保障您正常使用我们的服务，维护游戏基础功能的正常运行，优化游戏产品性能，提升您的游戏体验并保障您的账号安全，<strong>我们会收集您的设备ID、设备名称、设备类型和版本、系统版本、IP地址、设备识别符（如 IMEI、IMSI、MAC地址）、应用ID、网络类型等信息。</strong></p>
              <p>1.4 当您使用光宇游戏服务时，我们会收集您的游戏日志信息，例如登录日志、物品日志、游戏角色信息、交友记录等，以便您能够在客户端查看您的游戏历史记录，同时用于游戏运营统计分析、客服投诉处理及其他游戏安全分析，并为提升您的游戏体验，我们可能把前述信息同步至该游戏后续版本或您正在使用的我们提供的其他产品中。</p>
              <p>1.5 当您使用光宇游戏产品的消费功能时，<strong>我们会收集您的充值记录、消费记录等信息，以便您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。充值记录、消费记录属于敏感信息，收集上述信息为实现光宇游戏产品的消费功能所必须，否则将无法完成交易。</strong></p>
              <p>1.6 为保障您的游戏账号安全，营造公平、健康及安全的游戏环境，我们会收集您的游戏识别信息、硬件及操作系统信息、应用列表、进程及游戏崩溃记录等信息，以用于打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊等）。</p>
              <p>1.7 当您在游戏中通过文字、图片、语音、视频及其他方式与其他玩家进行互动，我们可能会收集并保存您发送的上述信息内容用于过滤色情、暴力、政治、辱骂、恶意广告等不当内容，以此净化游戏环境，维护健康的上网环境。</p>
              <p>1.8 如您希望通过图片、语音、视频与其他游戏玩家互动、参与直播，在您授权同意后，游戏会访问<strong>您的照片或存储文件、麦克风、摄像头，</strong>为您提供截图保存、图片上传、语音聊天、直播互动等功能。</p>
              <p>1.9 为保障游戏安全稳定运行并实现特定功能，部分游戏可能会接入第三方开发的软件工具开发包<a href="#software">（Software Development Kit，SDK，详见附件一）</a>。我们会对游戏接入的涉及个人信息收集的SDK进行安全监测，以保护您的个人信息安全。</p>
              <p>1.10 根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：</p>
              <p>1） 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；</p>
              <p>2） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
              <p>3） 出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</p>
              <p>4） 所收集的个人信息是您自行向社会公众公开的；</p>
              <p>5） 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
              <p>6） 根据您要求签订和履行合同所必需的；</p>
              <p>7） 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
              <p>8） 为开展合法的新闻报道所必需的；</p>
              <p>9） 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
              <p>10） 法律法规规定的其他情形。</p>
              <p>1.11 请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。</p>
              <p>1.12 <strong>人脸扫描信息</strong>，为保障您的账号安全，维护游戏公平环境，<strong>防止账号被盗用、外挂使用或其他异常操作行为</strong>，在您使用光宇游戏服务过程中，当系统检测到您的账号存在异常登录、操作行为异常或疑似安全风险时，我们可能会要求您进行人脸扫描验证。我们会在获得您的<strong>单独同意</strong>后进行人脸扫描，收集您的人脸图像、面部特征信息及相关验证结果。 该信息属于<strong>敏感个人信息，仅用于判断当前操作是否为账号注册主体本人</strong>，以保障账号安全及游戏环境的公平性。如您<strong>拒绝提供</strong>人脸扫描信息，我们将无法确认您的身份，可能导致您的账号<strong>被临时限制登录或部分功能受限，直至完成身份验证</strong>。</p>
              <p><strong>我们仅将人脸扫描信息用于上述安全验证目的</strong>，不会用于其他任何用途，亦不会将其用于用户画像、广告推送或其他商业目的。 人脸扫描完成后，原始人脸图像将在验证目的达成后<strong>及时删除或进行加密化处理</strong>，<strong>仅保留必要的验证结果记录</strong>（如验证状态、时间）。</p>
            </li>
            <li>
              <h4><strong>2.信息的存储</strong></h4>

              <p>2.1 信息存储的方式和期限</p>
              <p>我们会通过安全的方式存储您的信息，<strong>包括本地存储、APP数据缓存<a href="#appAuth">（APP权限调用详见附件二）</a>、数据库和服务器日志。</strong></p>
              <p>一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。<strong>对于人脸扫描信息</strong>，我们仅在完成身份验证所需的<strong>必要时间内保留原始人脸图像</strong>，验证完成后将<strong>立即删除或加密化处理；验证结果记录</strong>（如验证状态、时间）将按照法律法规要求及安全审计需要<strong>保留相应期限</strong>。</p>
              <p>2.2 信息存储的地域</p>
              <p>我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>
              <p>2.3 产品或服务停止运营时的通知</p>
              <p>当我们的产品或服务发生停止运营的情况时，我们将根据相关法律法规规定进行公告通知，并依法保障您的合法权益。</p>

            </li>
            <li>
              <h4><strong>3.信息安全</strong></h4>
              <p>3.1 安全保护措施</p>
              <p>我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。</p>
              <p>我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。此外，我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作，以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。</p>
              <p>我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。</p>
              <p>3.2 安全事件处置措施</p>
              <p>若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会以公告、推送通知或邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。</p>

            </li>
            <li>
              <h4><strong>4.我们如何使用信息</strong></h4>
              <p>我们严格遵守法律法规的规定以及与用户的约定，按照《光宇游戏保护隐私条款》所述使用收集的信息，以向您提供更为优质的服务。</p>
              <p>4.1 信息使用规则</p>
              <p>我们会按照如下规则使用收集的信息：</p>
              <p>1) 我们会根据我们收集的信息向您提供各项功能与服务，包括基础游戏功能、玩家互动功能、消费功能等；</p>
              <p>2) 我们会根据您使用光宇游戏产品的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合。</p>
              <p>4.2 告知变动目的后征得同意的方式</p>
              <p>我们将会在本指引所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。</p>


            </li>
            <li>
              <h4><strong>5.对外提供</strong></h4>
              <p>5.1
                除本协议以及《光宇通行证用户协议》规定的情形之外，我们不会主动共享、提供或转让您的个人信息至第三方，如存在其他共享、提供或转让您的个人信息或您需要我们将您的个人信息共享、提供或转让至第三方情形时，我们会以告知本协议更新的方式直接征得您的明示同意或间接通过该第三方征得您对上述行为的明示同意。</p>
              <p>为提升您的用户体验，例如优化广告效果（您可以在关于广告页面中了解和管理为您展示的广告）、推送特定活动或优惠等，我们可能需要向第三方合作伙伴等，分享已经匿名化或去标识化处理后的信息，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。</p>
              <p>我们不会向合作伙伴分享可用于识别您个人身份的信息（例如您的姓名或电子邮件地址），除非您明确授权。</p>
              <p>我们的人脸扫描验证服务由<strong>具备合法资质的第三方技术服务商提供</strong>，但我们会严格要求该等服务商按照本协议及法律法规的规定处理您的人脸信息，并要求其<strong>不得留存、使用或向他人提供</strong>您的人脸信息。</p>
              <p>5.2
                除非另有规定外，我们不会对外公开披露所收集的个人信息。如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。</p>
              <p>5.3
                随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息。</p>
              <p>5.4 根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：</p>
              <p>1） 与国家安全、国防安全直接相关的；</p>
              <p>2） 与公共安全、公共卫生、重大公共利益直接相关的；</p>
              <p>3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
              <p>4） 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
              <p>5） 个人信息主体自行向社会公众公开个人信息的；</p>
              <p>6） 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

            </li>
            <li>
              <h4>6.您的权利</h4>
              <p>在您使用光宇游戏服务期间，我们可能会视游戏产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息，您可参考相应游戏产品的具体指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。</p>

            </li>
            <li>
              <h4>7.联系我们</h4>
              <p>当您有其他的投诉、建议等相关问题请随时通过客服与我们联系。</p>
            </li>
            <li>
              <h4>8.其他</h4>
              <p>
                <strong>本隐私协议为《光宇通行证服务协议》的组成部分，若有任何与协议冲突的地方，以协议为准。当本协议发生变更时，我们会在版本更新时以合理的方式向您提示变更后的指引。请您仔细阅读变更后的隐私协议，您继续使用光宇游戏就表示您同意我们按照更新后的隐私协议处理您的个人信息。</strong>
              </p>

            </li>
            <li>
              <h4 id="software">附件一：</h4>
              <table border="1" cellspacing="0" cellpadding="0">
                <tr>
                  <th>SDK名称 </th>
                  <th>开发者 </th>
                  <th>使用目的 </th>
                  <th>收集个人信息字段及用途 </th>
                  <th>SDK隐私政策链接 </th>
                </tr>
                <tr>
                  <td>个推消息推送SDK</td>
                  <td>每日互动股份有限公司</td>
                  <td>为App用户提供消息推送技术服务</td>
                  <td width={"50%"}>
                    设备信息、网络信息：设备平台、设备厂商、设备品牌、设备型号及系统版本、OAID、AndroidID、WIFI连接信息、运营商信息、DHCP、SSID、BSSID、IMEI、MAC、Google Advertising ID（GAID）、Serial Number、IMSI、ICCID、IP地址、基站信息。用于生成唯一的推送目标ID（CID）和设备ID（GID）、位置相关信息、应用列表信息
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://docs.getui.com/privacy</td>
                </tr>
                <tr>
                  <td>Bugly Android</td>
                  <td>深圳市腾讯计算机系统有限公司</td>
                  <td>排查崩溃问题，帮助APP提升稳定性，识别Crash等问题</td>
                  <td width={"50%"}>
                    手机型号、手机品牌、AndroidID、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</td>
                </tr>
                <tr>
                  <td>Dynamic Ability SDK</td>
                  <td>华为软件技术有限公司</td>
                  <td>不涉及</td>
                  <td width={"50%"}>
                    此功能不需要收集、使用任何个人信息
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/agc-dynamicability-sdksecurity-0000001058890662</td>
                </tr>
                <tr>
                  <td>NetworkKit</td>
                  <td>华为软件技术有限公司</td>
                  <td>提供简单易用、低时延、高吞吐和高安全的端云传输通道</td>
                  <td width={"50%"}>
                    运营商信息、网络信息、SSID、IP地址、系统设置信息
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://developer.huawei.com/consumer/cn/doc/system-Guides/network-sdk-data-compliance-0000001050318444</td>
                </tr>
                <tr>
                  <td>QQ互联sdk（Android版本）</td>
                  <td>深圳市腾讯计算机系统有限公司</td>
                  <td>实现分享能力</td>
                  <td width={"50%"}>
                    设备型号信息、剪切板信息、内存卡权限、特定应用（QQ、TIM）的安装情况
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e</td>
                </tr>
                <tr>
                  <td>华为统一扫码SDK（Android版）</td>
                  <td>华为软件技术有限公司</td>
                  <td>为开发者应用提供码生成或扫码等能力</td>
                  <td width={"50%"}>
                    您主动提交的数据（图片、文本）、传感器信息（加速度传感器、光照传感器）、网络信息（网络类型、运营商信息、WLAN信息（WiFi状态））、应用信息（应用基本信息、可变设备标识符）、设备信息（设备型号、系统属性、操作系统信息）。
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050043971</td>
                </tr>
                <tr>
                  <td>微信OpenSDK Android</td>
                  <td>深圳市腾讯计算机系统有限公司</td>
                  <td>微信Open SDK是一款为开发者开发运营的APP提供实现微信分享与收藏、微信登录和微信支付功能等相关能力的软件开发工具包</td>
                  <td width={"50%"}>
                    用户主动选择的图片/内容；用户主动选择的微信头像、昵称信息；第三方应用生成的支付订单标识，传输支付状态（成功/失败）
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</td>
                </tr>
                <tr>
                  <td>微博移动SDK-android</td>
                  <td>北京微梦创科网络技术有限公司</td>
                  <td>用于实现微博分享功能，将用户选择的图片或视频分享至微博</td>
                  <td width={"50%"}>
                    获取用户选择的图片或视频
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://open.weibo.com/wiki/Sdk/privacy</td>
                </tr>
                <tr>
                  <td>身份认证（增强版）SDK</td>
                  <td>北京火山引擎科技有限公司</td>
                  <td>对人脸进行活体检测</td>
                  <td width={"50%"}>
                    身份证信息（姓名、身份证号码，使用OCR身份证信息提取的，还包含身份证件照片）；人脸视频和照片；应用版本、应用发布渠道、应用程序包名、androidid、SSID、运营商信息、传感器信息、IP地址；设备品牌、设备型号、操作系统、操作系统api版本
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://www.volcengine.com/docs/86081/1824129?lang=zh&_vtm_=a106466.b106468.0_0.0_0.0.8_7644863660204901951</td>
                </tr>
                <tr>
                  <td>OPPO PUSH 客户端SDK</td>
                  <td>广东欢太科技有限公司</td>
                  <td>消息推送服务</td>
                  <td width={"50%"}>
                    应用基本信息（MCS应用包名、应用版本号、OPPO PUSH SDK版本号），应用包名，应用内设备标识符（RegistraterID、appKey、appSecret）
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://open.oppomobile.com/new/developmentDoc/info?id=11228</td>
                </tr>
                <tr>
                  <td>小米推送SDK</td>
                  <td>北京小米移动软件有限公司</td>
                  <td>针对小米设备推送消息</td>
                  <td width={"50%"}>
                    设备信息（厂商、型号、归属地、运营商名称等）、设备内存、操作系统版本、小米推送SDK版本、推送消息内容、通知栏设置、网络类型、WIFI状态
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1534</td>
                </tr>
                <tr>
                  <td>vivo推送SDK</td>
                  <td>维沃移动通信有限公司</td>
                  <td>提供推送消息服务、统计推送SDK接口调用成功率</td>
                  <td width={"50%"}>
                    应用基本信息（appid，appkey，应用包名，应用版本号，pushSDK版本）、应用内设备标识符（regid）、设备的硬件信息（设备类型）、系统基本信息（系统类型、系统版本）
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://dev.vivo.com.cn/documentCenter/doc/878</td>
                </tr>
                <tr>
                  <td>华为推送SDK（Android版）</td>
                  <td>华为软件技术有限公司</td>
                  <td>用于消息推送</td>
                  <td width={"50%"}>
                    应用信息（应用基本信息）、设备信息（设备型号、操作系统信息、系统设置信息），网络信息（网络信息、运营商信息、SSID、IP地址）
                  </td>
                  <td style={{ width: '20%', whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-all' }}>https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</td>
                </tr>
              </table>
            </li>
            <li>
              <h4 id="appAuth">附件二：APP设备权限调用</h4>
              <table border="1" cellspacing="0" cellpadding="0">
                <tr>
                  <th width={"50%"}>权限 </th>
                  <th width={"50%"}>说明/用途 </th>
                </tr>
                <tr>
                  <td> 网络连接权限</td>
                  <td>查看网络连接</td>
                </tr>
                <tr>
                  <td>查看网络状态权限</td>
                  <td>查看网络连接状态</td>
                </tr>
                <tr>
                  <td>修改网络状态</td>
                  <td>判断是否联网</td>
                </tr>
                <tr>
                  <td>修改wifi网络状态</td>
                  <td>判断是否联网</td>
                </tr>
                <tr>
                  <td>编辑短信</td>
                  <td>编辑上行短信</td>
                </tr>
                <tr>
                  <td>拨打电话权限</td>
                  <td>拨打官方客服电话</td>
                </tr>
                <tr>
                  <td>闪光灯权限</td>
                  <td>昏暗环境下扫描二维码进行登录</td>
                </tr>
                <tr>
                  <td>相机权限</td>
                  <td>扫描二维码进行登录</td>
                </tr>
                <tr>
                  <td>相机硬件权限</td>
                  <td>相机功能，用于指定应用程序需要访问设备的摄像头功能</td>
                </tr>
                <tr>
                  <td>相机自动对焦权限</td>
                  <td>相机功能，用于指定应用程序需要访问设备摄像头的自动对焦功能</td>
                </tr>
                <tr>
                  <td>安装其他应用程序的权限  </td>
                  <td>安装奇宝斋、口袋版官方应用</td>
                </tr>
                <tr>
                  <td>结束后台进程权限</td>
                  <td>结束光宇通进程</td>
                </tr>
                <tr>
                  <td>允许程序挂载、反挂载外部文件系统权限</td>
                  <td>清除缓存数据</td>
                </tr>
                <tr>
                  <td>允许程序显示系统窗口权限</td>
                  <td>悬浮消息通知</td>
                </tr>
                <tr>
                  <td>读取设备的外部存储空间中的文件</td>
                  <td>获取相册内容</td>
                </tr>
                <tr>
                  <td>写入外部存储,如SD卡上写文件</td>
                  <td>皮肤缓存，图片缓存，用于设置自定义皮肤</td>
                </tr>
                <tr>
                  <td>允许程序开机自动运行</td>
                  <td>接收消息推送</td>
                </tr>
                <tr>
                  <td>授予应用对其相册中图片和视频的访问权限</td>
                  <td>扫码、问题反馈图片上传、账号修复选择相册图片</td>
                </tr>
              </table>
            </li>
          </ul>
          &nbsp;<br />
          <div style={{ textAlign: 'right' }}><strong>更新时间：2026年07月08日</strong></div>
          <div style={{ textAlign: 'right' }}><strong>生效时间：2026年07月08日</strong></div>
        </div>
      </div>

    </div>
  )
}
